import Button from "@components/Button";
import StaticContentDiv from "@components/StaticContent";
import { APP_LOGO, APP_NAME, RETAILER_LOGO } from "@utils/constants";
import { Helmet } from "react-helmet";
import { RiLoginCircleLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";

import NearestRetailer from "../../containers/HomePage/components/ui/NearestRetailer";

import Modal from "@components/Modal";

const PublicLayout = () => {
  const navigate = useNavigate();

  const [openVisit, setOpenVisit] = useState(false);

  const handleToggleOpenVisit = () => setOpenVisit((prev) => !prev);

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <Helmet>
        <title>{APP_NAME}</title>
      </Helmet>
      <div className='grid grid-cols-1 min-h-screen grid-rows-[auto_1fr_auto] container-public'>
        <header className='shadow py-3 px-4 xl:px-0 sticky top-0 z-30 bg-white'>
          <div className='container mx-auto grid grid-cols-2 lg:flex justify-between items-center gap-x-4'>
            <Link to='/'>
              <img className='lg:w-48' src={APP_LOGO} alt={APP_NAME} />
            </Link>
            <img
              className='lg:w-64 lg:order-3'
              src={RETAILER_LOGO}
              alt={APP_NAME}
            />{" "}
            <div
              className='text-blue-400 underline cursor-pointer text-sm text-center lg:text-right flex-1 col-span-2 mt-4 lg:mt-0'
              onClick={handleLogin}
            >
              Retail Login
            </div>
            <div className='flex items-center gap-4'>
              <Modal
                title='Search retailer nearest to your location.'
                opened={openVisit}
                onClose={handleToggleOpenVisit}
                className='w-4/5 md:w-3/4 lg:w-1/2'
              >
                <NearestRetailer />
              </Modal>
              {/* <div className='flex lg:flex-row flex-col items-center'>
                <div className='mx-auto lg:order-2'></div>
                <div className='flex items-center gap-4 mt-2'>
                  <div onClick={handleToggleOpenVisit}>
                    <StaticContentDiv content_key='contact2' />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </header>
        <main className='px-4 xl:px-0'>
          <Outlet />
        </main>
        <footer>
          <StaticContentDiv content_key='footer' />
        </footer>
      </div>
    </>
  );
};

export default PublicLayout;
